import { responsiveFontSize } from '@/hooks/useResponsiveDimensions';
import colors from '@/config/colors';

let iconSize = responsiveFontSize(3);

function setStarIconSize(stars: number) {
  const achievedStars = stars;

  if (achievedStars <= 3) {
    return iconSize * 3;
  } else if (achievedStars <= 6 && achievedStars > 3) {
    return iconSize * 2;
  } else if (achievedStars > 6 && achievedStars < 12) {
    return iconSize * 1.5;
  } else {
    return iconSize * 1.1;
  }
}

export function openDailyGoal(dailyGoal: number, stars: number) {
  const emptyStars = dailyGoal - stars;
  const generatedStars = [];

  const size = setStarIconSize(dailyGoal);

  for (let i = 0; i < stars; i++) {
    generatedStars.push({
      name: 'star',
      size,
      color: colors.gold,
      solid: true,
      key: i + 'g',
    });
  }
  for (let i = 0; i < emptyStars; i++) {
    generatedStars.push({
      name: 'star',
      size,
      color: colors.grey,
      solid: true,
      key: i + 'e',
    });
  }

  return generatedStars;
}
